import { FieldValues } from 'react-hook-form/dist/types';

import { ControlledDatePickerProps } from './controlled-datepicker.model';
import { ControlledDatePickerView } from './controlled-datepicker.view';

// Decision making component
// This component will be responsible for deciding which UI to render
// based on the current state of the application
export const ControlledDatePickerController = <T extends FieldValues>(
  props: ControlledDatePickerProps<T>
) => {
  const transformMaxDate = () => {
    const maxDate = props.attribute.rules?.find(
      (data) => data.type === 'max'
    )?.value;

    if (!maxDate) return undefined;

    if (maxDate === '@today') {
      const today = new Date();
      return today;
    }

    const date = new Date(maxDate as string);
    return date;
  };

  const tranformMinDate = () => {
    const minDate = props.attribute.rules?.find(
      (data) => data.type === 'min'
    )?.value;

    if (!minDate) {
      const today = new Date();
      return today;
    }

    if (minDate === '@today') {
      const today = new Date();
      return today;
    }

    const date = new Date(minDate as string);
    return date;
  };

  return (
    <ControlledDatePickerView
      {...{ ...props, transformMaxDate, tranformMinDate }}
    />
  );
};
